import * as React from 'react'

const Logo = (props: React.ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      src="/vet-portal/logo.webp"
      alt="Adapet Medical"
      width={props.width ?? 156}
      height={props.height ?? 36}
      {...props}
    />
  )
}

export default Logo
